import { render, staticRenderFns } from "./LoadingOrderQuery.vue?vue&type=template&id=3dd10908&scoped=true"
import script from "./LoadingOrderQuery.vue?vue&type=script&lang=js"
export * from "./LoadingOrderQuery.vue?vue&type=script&lang=js"
import style0 from "./LoadingOrderQuery.vue?vue&type=style&index=0&id=3dd10908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd10908",
  null
  
)

export default component.exports